import Vue from 'vue'
import BootstrapVue, { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueMask from 'v-mask'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueCompositionAPI from '@vue/composition-api'
import '@/styles/global.css'
import '@/styles/__global.scss'
import 'dotenv/config'
import 'element-ui/lib/theme-chalk/index.css'
import Big from 'big.js'
import Cryptojs from 'vue-cryptojs'
import ElementUI from 'element-ui'
import VueFileAgentStyles from 'vue-file-agent/dist/vue-file-agent.css'
import VueFileAgent from 'vue-file-agent'
import AppEchartLine from '@core/components/charts/echart/AppEchartLine.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import 'vue-select/dist/vue-select.css'
import '@axios'
import '@/libs/acl'
import '@casl/ability'
import '@/libs/sweet-alerts'
import '@/libs/tour'
import Ripple from 'vue-ripple-directive'
import ptBr from 'element-ui/lib/locale/lang/pt-br'
import App from './App.vue'
import store from './store'
import router from './router'

// Global Components
import './global-components'

// import 'moment'

// eslint-disable-next-line import/order
import VueMoment from 'vue-moment'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'

// require videojs style
import 'video.js/dist/video-js.css'
// eslint-disable-next-line import/order
import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.snow.css'

export const EventBus = new Vue()

Vue.use(VueQuillEditor)
Vue.use(VueMoment, {
})

Vue.use(VueMask);
Vue.directive('ripple', Ripple)

Vue.use(VueFormWizard)

// import 'bootstrap-vue'
Vue.use(BootstrapVue)

// import 'VueCryptojs)'
Vue.use(Cryptojs)

// import 'vue-video-player/src/custom-theme.css'
Vue.use(ToastificationContent)

ElementUI.Dropdown.methods.hide = function hide() {
  const _this2 = this

  if (!this.triggerElm || this.triggerElm.disabled) return
  this.removeTabindex()
  if (this.tabindex >= 0) {
    this.resetTabindex(this.triggerElm)
  }
  clearTimeout(this.timeout)
  this.timeout = setTimeout(() => {
    _this2.visible = false
  }, this.trigger === 'click' ? 0 : this.hideTimeout)
}

Vue.use(ElementUI, {
  locale: ptBr,
})

Vue.use(VueFileAgentStyles)
Vue.use(VueFileAgent)

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(AppEchartLine)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  Big,
  render: h => h(App),
}).$mount('#app')
